import "@/assets/vendor/nucleo/css/nucleo.css";
import "@/assets/vendor/wf/css/ems.css";
import "@/assets/scss/argon.scss";
import globalComponents from "./globalComponents";
import globalDirectives from "./globalDirectives";
import SidebarPlugin from "@/components/SidebarPlugin/index"
import NotificationPlugin from "@/components/NotificationPlugin/index"
import VueMoment from 'vue-moment'
import VJsoneditor from 'v-jsoneditor/src/index'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'

// import 'bootstrap/dist/css/bootstrap.css'
// import 'bootstrap-vue/dist/bootstrap-vue.css'


export default {
  install(Vue) {
    Vue.use(globalComponents);
    Vue.use(globalDirectives);
    Vue.use(SidebarPlugin);
    Vue.use(NotificationPlugin);
    Vue.use(VueMoment);
    Vue.use(VJsoneditor);
    Vue.use(BootstrapVue);
    Vue.use(IconsPlugin);
  }
};
